import type { RouteRecordRaw } from "vue-router";

export const HomeRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'homeView',
        component: () => import('./Home.vue')
    },
    {
        path: 'inbox',
        name: 'homeInbox',
        component: () => import('./Inbox.vue')
    },
]